export default {
  common: {
    email: 'Email',
    phone: 'Telepon',
    phoneNumber: 'Nomor Telepon',
    countrySelect: 'Pilih negara',
    countryUnmodifiedNote: 'Negara tidak dapat diubah setelah registrasi',
    next: 'Berikutnya',
    back: 'Kembali',
    attention: 'Perhatian',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    modify: 'Ubah',
    ignore: 'Abaikan',
    firstName: 'Nama Depan',
    middleName: 'Nama Tengah',
    lastName: 'Nama Belakang',
    gender: 'Jenis Kelamin',
    male: 'Pria',
    female: 'Wanita',
    birthday: 'Ulang Tahun',
    graphicCode: 'Kode Grafik',
    emailCode: 'Kode Verifikasi Email',
    smsCode: 'Kode SMS',
    smsVerificationCode: 'Kode verifikasi SMS',
    bind: 'Ikat',
    send: 'Kirim',
    resend: 'Kirim Ulang',
    address: 'Alamat',
    done: 'Selesai',
    systemMessage: 'Pesan Sistem',
    setting: 'Pengaturan',
    submit: 'Kirim',
    language: 'Bahasa',
    edit: 'Edit',
    delete: 'Hapus'
  },
  account: {
    account: 'Akun',
    nickname: 'Nama Panggilan',
    id: 'ID',
    basicInfo: 'Level Dasar',
    placeholder: 'Silakan masukkan',
    completed: 'Selesai',
    semiInfo: 'Semi-Terverifikasi',
    fullyInfo: 'Sepenuhnya Terverifikasi',
    basicTab: 'Dasar',
    advancedTab: 'Lanjutan',
    linkedAccount: 'Akun Penarikan Tertaut',
    accountSecurity: 'Akun dan Keamanan MetWallet',
    logout: 'Keluar',
    semiToast: 'Silakan selesaikan verifikasi Level Dasar',
    fullyToast: 'Silakan selesaikan \n Level Dasar dan Semi-Terverifikasi',
    quickLoginTitle: 'Login Cepat',
    cancelQuickLogin: 'Apakah Anda yakin ingin menonaktifkan Login Cepat?'
  },
  accountSecurity: {
    title: 'Akun dan Keamanan',
    payPwd: 'Kata Sandi Pembayaran',
    loginPwd: 'Kata Sandi Masuk',
    changeEmail: 'Ubah Email',
    changePhone: 'Ubah Nomor Telepon',
    changePayPwd: 'Ubah Kata Sandi Pembayaran',
    changeLoginPwd: 'Ubah Kata Sandi Masuk',
    bindEmail: 'Ikat Email',
    bindEmailNote: 'Lulus verifikasi Email untuk mengikatnya',
    bindEmailPlaceholder: 'Masukkan Email yang ingin Anda ikat',
    smsBindNote: 'Lewati verifikasi SMS untuk mengikatnya',
    bindPhone: 'Ikat Nomor Telepon',
    smsAuthentication: 'Autentikasi SMS',
    emailAuthentication: 'Autentikasi Email',
    phoneVerificationNote: 'Lulus verifikasi nomor telepon saat ini terlebih dahulu',
    bindPhonePlaceholder: 'Masukkan nomor telepon yang ingin Anda ikat',
    verificationWrongToast: 'Silakan periksa kode verifikasi Anda',
    phoneNumberEmptyToast: 'Silakan isi nomor telepon',
    verificationCodeEmptyToast: 'Silakan isi kode',
    wrongCodeToast: 'Kode salah',
    changeNote: 'Silakan lewati verifikasi untuk mengubahnya.',
    newEmailVerification: 'Verifikasi Email Baru',
    newEmailPlaceholder: 'Masukkan Email baru Anda',
    change: 'Ubah',
    emailLowercaseToast: 'Email harus ditulis dalam huruf kecil.',
    newEmailEmptyToast: 'Harap isi email baru',
    changeSuccessToast: 'Ubah berhasil',
    phonePlaceholder: 'Masukkan telepon',
    currentEmail: 'Email Saat Ini',
    passCurrentEmailVerificationFirst: 'Lulus verifikasi Email saat ini terlebih dahulu',
    currentEmailVerification: 'Verifikasi Email Saat Ini',
    smsVerification: 'Verifikasi SMS',
    currentPhoneNumber: 'Nomor Telepon Saat Ini',
    currentPhoneVerification: 'Verifikasi Telepon Saat Ini',
    currentEmailAddress: 'Alamat Email Saat Ini',
    phoneVerification: 'Verifikasi Telepon',
    enterVerificationCode: 'Masukkan kode verifikasi',
    newPhoneNumber: 'Nomor telepon baru',
    newEmail: 'Email baru'
  },
  withdrawAccount: {
    selectAccountType: 'Pilih Jenis Akun',
    noBasicLevelVerificationDialog: 'Silakan selesaikan verifikasi Level Dasar sebelum mengikat metode penarikan.',
    bindNote: 'Harap isi informasi akun yang benar, atau penarikan Anda akan terpengaruh.',
    bindBankAccount: 'Ikat Rekening Bank',
    bindMobileMoneyAccount: 'Ikat Rekening Uang Seluler',
    fieldEmptyToast: '{0} diperlukan',
    fieldLengthToast: '{0} harus berisi setidaknya {1} karakter',
    bindBankRepeatToast: 'Jangan ikat rekening bank yang sama berulang kali!',
    accountName: 'Nama Akun',
    ifscCode: 'Kode IFSC',
    accountEmptyToast: 'Akun diperlukan',
    accountNameEmptyToast: 'Nama Akun diperlukan',
    phoneEmptyToast: 'Telepon diperlukan',
    emailEmptyToast: 'Email diperlukan',
    ifscCodeEmptyToast: 'Kode IFSC diperlukan',
    ifscCodeLengthToast: 'Kode IFSC harus 11 digit',
    bindIMPSRepeatToast: 'Jangan ikat akun IMPS yang sama berulang kali!',
    bindNote2:
      'Silakan isi alamat TRC-20 Anda yang benar. Alamat yang salah akan menyebabkan pembayaran hilang, yang bukan tanggung jawab kami.',
    usdtAddress: 'Alamat USDT (TRC-20):',
    minimumLimit: 'Minimal penarikan per transaksi: $10',
    usdtFee: 'Biaya: Mengikuti biaya aktual',
    registerGcash: 'Jika Anda tidak memiliki akun Gcash, silakan klik di sini untuk mendaftar.',
    registerEpay: 'Jika Anda tidak memiliki akun Epay, silakan klik di sini untuk mendaftar.',
    bindThirdPartyTitle: 'Ikat Akun {0}',
    wrongAccountToast: 'Akun salah',
    accountFormatToast: 'Format akun salah',
    bindThirdPartyFailedToast: 'Pengikatan {0} gagal',
    queryFailedToast: 'Permintaan Gagal.',
    editFailedToast: 'Pengeditan Gagal.',
    add: 'Tambah',
    confirmEditDialog: 'Apakah Anda yakin akan mengedit akun {0}?',
    payPwdRequireDialog: 'Harap tetapkan kata sandi pembayaran 6 digit sebelum menambahkan akun.',
    unbindFailedToast: 'Gagal melepaskan ikatan',
    cashOutSuccessNote: 'Perkiraan waktu kedatangan: dalam 7 hari kerja',
    requestSubmitted: 'Permintaan penarikan telah dikirim',
    amountLimitToast1: 'Jumlah penarikan dana harus ≥$40,00',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'Jumlah penarikan dana harus ≥${0},00',
    recommendAmountNote:
      // eslint-disable-next-line no-template-curly-in-string
      'Tips: Mengakumulasikan jumlah hingga ${0} sebelum penarikan akan secara efektif menghemat biaya pemrosesan Anda.',
    amountNotEnoughToast: 'Jumlah penarikan dana tidak cukup',
    exceedingLimitToast1: 'Jumlah penarikan dana hari ini telah mencapai batas atas',
    exceedingLimitToast2:
      'Jumlah penarikan dana hari ini telah mencapai batas atas. Apakah Anda perlu menyelesaikan sertifikasi lanjutan untuk menaikkan batas?',
    restrictedCountriesPayPalAccountToast:
      'Jangan gunakan akun PayPal negara yang dibatasi, yang akan menyebabkan Arripay Anda diblokir',
    withdrawMinimumToast: 'Minimum penarikan untuk setiap transaksi: $40',
    bankNotAvailableToast:
      'Bank ini tidak tersedia lagi, harap ikat bank lain. Akun USDT ini tidak dapat ditarik, harap gunakan akun baru untuk penarikan.',
    usdtAccountInvalidToast: '',
    noPayPwdToast: 'Harap tetapkan kata sandi pembayaran 6 digit sebelum melakukan penarikan.',
    editBankAccount: 'Edit Rekening Bank',
    accountPlaceholder: 'Masukkan akun Anda',
    trc20Placeholder: 'Masukkan alamat TRC-20',
    accountRepeatToast: 'Sama seperti yang sekarang.',
    unbindBankCardConfirmDialog: 'Anda yakin ingin membatalkan ikatan kartu bank {0}?',
    unbindMobileMoneyAccountConfirmDialog: 'Anda yakin ingin membatalkan ikatan akun uang seluler {0}?',
    unbindAccountConfirmDialog: 'Anda yakin ingin membatalkan ikatan akun {0}?',
    availableBalance: 'Saldo tersedia {0}',
    estimatedFee: 'Perkiraan biaya',
    submitFailToast: 'Pengiriman gagal',
    disabledMethodToast: 'Saluran ini untuk sementara tidak tersedia',
    channelUnavailableTitle: 'Saluran tidak tersedia',
    channelUnavailableNote: 'Saluran penarikan ini untuk sementara tidak tersedia. Silakan coba cara lain.',
    channelUnavailableOk: 'OK',
    bankTransferUnavailableTitle: 'Transfer Bank tidak tersedia',
    bankTransferUnavailableNote:
      'Transfer Bank tidak tersedia untuk akun Anda saat ini. Silakan gunakan Epay untuk menarik dana.',
    channelMaintenanceTitle: 'Saluran sedang dalam pemeliharaan',
    channelMaintenanceNote: 'Saluran penarikan ini sedang dalam pemeliharaan. Silakan coba cara lain.',
    bankInfoUpdateTitle: 'Perbarui info bank Anda',
    bankInfoUpdateNote: 'Karena penyesuaian kebijakan Bank, harap perbarui data bank Anda untuk melanjutkan.',
    bindEpay: 'Hubungkan Epay',
    useEpay: 'Gunakan Epay',
    iMPSMaxLimitToast: 'Jumlah penarikan maksimum untuk satu transaksi melalui saluran ini adalah $260',
    linkedAccount: 'Rekening ditambahkan',
    otherAccounts: 'Akun lain dapat ditambahkan',
    withdrawTo: 'Transfer ke',
    withdrawAmount: 'Jumlah transfer',
    withdrawable: 'Dapat ditarik',
    documentIdToast: 'Nomor ID hanya boleh berisi angka',
    noAvailableMethodNote: 'Tidak ada metode penarikan yang tersedia',
    recommended: 'Rekomendasi'
  },
  paymentCode: {
    changePayPwd: 'Ubah Kata Sandi Pembayaran',
    setPayPwd: 'Tetapkan Kata Sandi Pembayaran',
    setPayPwdNote: 'Harap tetapkan kata sandi pembayaran 6 digit',
    reenterPayPwdNote: 'Masukkan lagi',
    verificationNote: 'Harap lewati verifikasi untuk menetapkannya.',
    emailVerification: 'Verifikasi Email',
    inconsistentPasswordToast: 'Kata sandi tidak konsisten',
    payPwdNote: 'Harap masukkan kata sandi pembayaran',
    payPwdFormatToast: 'Kata sandi pembayaran adalah angka 6 digit',
    payPwdWrongToast: 'Kata sandi pembayaran salah',
    payPwdVerificationFailToast: 'Verifikasi kata sandi pembayaran gagal!',
    successToast: 'Tetapkan \n dengan sukses'
  },
  authorize: {
    requirement:
      '{0} perlu memperoleh informasi berikut dari MetWallet Anda{1} untuk menyediakan layanan terkait bagi Anda. Nama Panggilan, Avatar, Jenis Kelamin, dll.',
    authorize: 'Otorisasi',
    switchAccount: 'Ganti Akun',
    goToMetWallet: 'Buka MetWallet',
    notMatchTips: 'Operasi gagal. Anda hanya dapat mengaktifkan Login Cepat dengan akun MetWallet Anda yang terikat'
  },
  basicLevel: {
    namePlaceholder: 'Tanpa simbol, angka',
    verification: 'Verifikasi',
    whatsAvailable: 'Apa yang tersedia',
    cashOut: 'Penarikan Tunai',
    withdrawLimit: '$50 Per Hari',
    basicLevelNote:
      'Harap masukkan informasi pribadi asli Anda. Informasi yang salah dapat menyebabkan penarikan dana gagal.',
    fieldEmptyToast: 'Silakan isi semua kolom yang diperlukan.',
    successToast: 'Tersimpan \n berhasil',
    failToast: 'Penyimpanan gagal',
    confirmDialog:
      'Pastikan memasukkan informasi pribadi asli Anda. Informasi yang salah dapat menyebabkan penarikan dana gagal.',
    birthdayFormatToast: 'Format bidang Tanggal Lahir salah',
    verificationCodeError: 'Kode verifikasi salah',
    verificationCodeEmpty: 'Kode verifikasi kosong',
    noEmailCodeToast: 'Silakan dapatkan kode verifikasi email',
    checkDialogTitle: 'Periksa info Anda',
    checkDialogContent:
      'Untuk menarik dana dengan sukses, harap periksa informasi Anda. Informasi yang salah dapat menyebabkan penarikan dana gagal.',
    check: 'Periksa'
  },
  semiVerified: {
    uploadPhotoId: 'Unggah Foto ID',
    photoId: 'Foto ID',
    resubmit: 'Kirim Ulang',
    limit: '$5.000 Per Hari',
    uploading: 'Mengunggah...',
    notUploadProofToast: 'Harap unggah bukti kartu identitas'
  },
  fullyVerified: {
    frontOfId: 'Bagian depan ID',
    backOfId: 'Bagian belakang ID',
    uploadIdFront: 'Unggah bagian depan ID',
    uploadIdBack: 'Unggah bagian belakang ID',
    withdrawDailyHint: 'Isi info untuk menarik > {0} per hari.',
    notUploadIdToast: 'Unggah bagian depan dan belakang ID Anda',
    proofTitle: 'DOKUMEN BUKTI TEMPAT TINGGAL',
    acceptableProof: 'BUKTI TEMPAT TINGGAL YANG DAPAT DITERIMA ADALAH:',
    acceptableProof1: 'Laporan rekening bank.',
    acceptableProof2: 'Tagihan utilitas (listrik, air, internet, dll.).',
    acceptableProof3: 'Dokumen yang dikeluarkan pemerintah (laporan pajak, sertifikat tempat tinggal, dll.).',
    unacceptableProof:
      'Kami tidak dapat menerima alamat pada dokumen identitas yang Anda serahkan sebagai bukti tempat tinggal yang sah.',
    limit: '$10.000 Per Hari',
    notUploadToast: 'Silakan unggah dokumen bukti tempat tinggal',
    incorrectFormatToast: 'Silakan unggah gambar jpg/png/jpeg.'
  },
  loginAndRegister: {
    pwd: 'Kata Sandi',
    lastLogin: 'Login Terakhir',
    moreOptions: 'Pilihan Lainnya',
    agreeCheckboxContent: 'Setujui {0} dan {1}',
    userAgreement: 'Perjanjian Pengguna',
    privacyPolicy: 'Kebijakan Privasi',
    notAgreeToast: 'Setujui Perjanjian Pengguna dan Kebijakan Privasi',
    forgotPassword: 'Lupa Kata Sandi',
    linkedMail: 'Email Tertaut',
    verificationCode: 'Kode Verifikasi',
    newPwd: 'Kata Sandi Baru',
    repeatPwd: 'Ulangi Kata Sandi',
    confirmPwd: 'Konfirmasi Kata Sandi',
    noLinkedEmailToast: 'Tidak ada Email tertaut dengan akun Anda',
    unregisteredToast: 'Nomor ini belum terdaftar',
    pwdFormatToast: 'Format kata sandi salah',
    resetSuccessToast: 'Atur ulang \n berhasil',
    pwdNotMatchToast: 'Kata sandi tidak cocok dua kali',
    emailFormatToast: 'Format Email Salah',
    phoneNumberFormatToast: 'Format nomor telepon salah',
    invalidAreaCodeToast: 'Kode area tidak valid',
    login: 'Login',
    pwdLogin: 'Login melalui kata sandi',
    emailCodeLogin: 'Login melalui kode verifikasi Email',
    smsLogin: 'Login melalui SMS',
    verifyEmail: 'Verifikasi Email',
    verifyPhone: 'Verifikasi Telepon',
    accountDangerDialog:
      'Akun Anda telah terdeteksi berbahaya. Harap verifikasi ulang akun Anda, jika tidak, akun Anda tidak akan dapat terus digunakan.',
    sendEmailCodeDialog: 'Kami telah mengirimkan kode verifikasi ke email {0} Anda. Harap masukkan kode verifikasi.',
    sendSmsCodeDialog: 'Kami telah mengirimkan kode verifikasi ke telepon {0} Anda. Harap masukkan kode verifikasi.',
    graphicCodeEmptyToast: 'Harap masukkan kode grafis.',
    countryUnselectToast: 'Harap pilih negara Anda terlebih dahulu',
    unsupportedLoginTypeToast: 'Jenis login tidak didukung',
    pwdWrongLimitOverDialog:
      'Kata sandi yang salah telah dimasukkan sebanyak 3 kali. Harap gunakan kode verifikasi SMS untuk login.',
    loginFailedToast: 'Login gagal',
    signIn: 'Masuk',
    pwdPlaceholder: 'Masukkan kata sandinya',
    pwdNote: 'Masukkan 8-16 karakter (huruf dan angka)',
    reenterPwdPlaceholder: 'Masukkan kembali kata sandi',
    reenterPwdNote: 'Harap masukkan kembali kata sandi',
    createAccount: 'Buat Akun',
    chooseCountryNote: 'Harap pilih negara',
    pwdInconsistentToast: 'Tidak sama dengan kata sandi sebelumnya yang Anda masukkan',
    createSuccessToast: 'Buat \n berhasil',
    registerFailToast: 'Pendaftaran gagal',
    userNotExistToast: 'Pengguna tidak ada',
    phoneIncorrectToast: 'Harap periksa telepon Anda',
    userExistToast: 'Pengguna sudah ada',
    countryCodeRepeatToast: 'Harap jangan masukkan kode negara berulang kali!',
    logoutDialog: 'Anda yakin untuk keluar?',
    pwdRequirement: 'Kata sandi harus terdiri dari minimal 8 hingga 16 karakter dengan huruf dan angka',
    signup: 'Daftar',
    registerSuccessToast: 'Daftar \n dengan sukses',
    oldPwdErrorToast: 'Silakan periksa kata sandi lama Anda'
  },
  checkUserInfo: {
    title: 'Pusat Manajemen',
    emptyInfoNote: 'Tidak ada informasi untuk akun saat ini, harap periksa akun MetWallet yang perlu Anda verifikasi.',
    infoNote: 'Berikut adalah informasi verifikasi Anda.',
    lastSuccessWithdrawal: 'Penarikan terakhir yang berhasil',
    copyBtn: 'Salin',
    successToast: 'Disalin Berhasil!',
    failToast: 'Gagal menyalin!'
  },
  country: {
    title: 'Pilih Wilayah',
    popular: 'Populer'
  },
  documentDetails: {
    title: 'Detail Dokumen',
    contract: 'Kontrak',
    goToSign: 'Buka untuk menandatanganinya',
    download: 'Unduh',
    upload: 'Unggah',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., dokumen saja.',
    contentEmptyToast: 'Harap masukkan konten',
    placeOfBirth: 'Tempat Lahir',
    occupation: 'Pekerjaan',
    fileForm: '(Formulir Berkas)',
    proofOfAddress: 'Bukti Alamat dalam Bahasa Inggris',
    residenceDoc: 'Dokumen Tempat Tinggal',
    textForm: '(Formulir Teks)',
    contractAgent: 'Agen Kontrak',
    contractPayslip: 'Slip Gaji Kontrak',
    uncompletedToast: 'Harap lengkapi untuk mengirim',
    successToast: 'Kirim Berhasil',
    undefinedFileTypeToast: 'Jenis unggahan file tidak ditentukan',
    uploadFailToast: 'Unggahan gagal'
  },
  filters: {
    amount: 'Jumlah',
    filter: 'Filter',
    time: 'Waktu',
    reset: 'Atur Ulang',
    timePickerTitle: 'Pilih {0} Waktu',
    start: 'Mulai',
    end: 'Akhir',
    maximum: 'Maksimal',
    minimum: 'Minimal'
  },
  home: {
    balance: 'Saldo',
    transactions: 'Transaksi',
    availableBalance: 'Saldo yang Tersedia',
    noWithdrawalMethodToast: 'Minimal satu metode penarikan diperlukan.',
    linkAccount: 'Tautkan Akun',
    all: 'Semua',
    cashIn: 'Uang Tunai',
    loading: 'memuat...',
    noMore: 'Tidak ada lagi transaksi',
    reload: 'Pemuatan gagal, klik untuk memuat ulang',
    receivedFrom: 'Diterima dari',
    transferredTo: 'Ditransfer ke',
    fee: 'Biaya transfer ke',
    myEmail: 'Email Saya',
    myPhone: 'Telepon Saya',
    invalidBasicLevelDialog:
      'Karena penyertaan simbol, spasi, atau angka di kolom nama Anda, penarikan dari akun tidak dapat dilakukan. Harap isi kembali informasi dasar (pastikan nama tidak menyertakan simbol, spasi, atau angka dan jika Anda tidak memiliki nama keluarga atau nama tengah, kosongkan saja.)',
    lackLastNameDialog: 'Nama Belakang Anda tidak diisi, yang akan menghambat penarikan Anda.',
    fillIn: 'Isi',
    viewDetails: 'Lihat Detail',
    docReviewingDialogTitle: 'Harap tunggu dokumen tersebut disahkan.',
    docReviewingDialogContent:
      'Anda telah menyerahkan dokumen, tetapi Anda tidak dapat menggunakan MetWallet sebelum dokumen Anda disahkan.<br>Staf resmi akan segera memprosesnya, harap tunggu sebentar.',
    docPassedDialog:
      'Dokumen yang Anda serahkan disahkan. <br>Anda dapat menggunakan MetWallet seperti biasa sekarang.',
    docUnqualifiedDialog:
      'Dokumen yang Anda serahkan tidak memenuhi syarat. <br>Harap serahkan dokumen yang memenuhi syarat.',
    goToSubmit: 'Kirimkan dokumen tersebut',
    uncompletedDialog: 'Anda harus melengkapinya untuk menggunakan MetWallet seperti biasa',
    useMetWalletNormallyAfterPassed: 'Anda dapat menggunakan MetWallet seperti biasa setelah dokumen disahkan.',
    requireSemiVerifiedDialog:
      '{0}, untuk persyaratan bank, Anda harus menyelesaikan bagian semi-verifikasi dalam waktu 48 jam agar penarikan berhasil.',
    goToVerify: 'Verifikasi',
    emailInvalidDialog:
      '{0}, alamat email Anda sama dengan milik orang lain. Untuk asuransi privasi, harap masukkan alamat email Anda sendiri sesegera mungkin.',
    later: 'Nanti',
    transferRequireSemiVerifiedDialog: 'Harap selesaikan verifikasi Semi-Terverifikasi sebelum transfer.',
    modifyBtnText: 'Ubah Info Saya',
    unmodifiedTitle: 'Tidak Dapat Memodifikasi',
    unmodifiedContent: 'Anda memiliki pesanan penarikan yang sedang diproses. Informasi tidak dapat diubah sekarang.'
  },
  signing: {
    signature: 'Tanda tangan',
    date: 'Tanggal',
    employeeName: 'Nama Karyawan',
    designation: 'Jabatan',
    month: 'Bulan',
    year: 'Tahun',
    earnings: 'Penghasilan',
    deductions: 'Potongan',
    basic: 'Pokok & DA(USD)',
    totalAddition: 'Total Penambahan',
    totalDeduction: 'Total Potongan',
    salary: 'Gaji Bersih',
    refNo: 'Nomor Referensi',
    paymentTransferDate: 'Tanggal Transfer Pembayaran',
    nameOfBank: 'Nama Bank',
    signatureOfEmployee: 'Tanda Tangan Karyawan',
    director: 'Direktur',
    signNote: 'Harap tanda tangani nama Anda',
    preview: 'Pratinjau',
    clear: 'Hapus',
    save: 'Simpan',
    noSignatureToast: 'Anda tidak dapat menyimpan tanpa tanda tangan.',
    fieldEmptyToast: 'Harap isi semua informasi.'
  },
  transactionDetail: {
    title: 'Detail Transaksi',
    status: 'Status',
    pending: 'Tertunda',
    completed: 'Selesai',
    success: 'BERHASIL',
    failed: 'Gagal',
    cancelled: 'Dibatalkan',
    onHold: 'Ditunda',
    reason: 'Alasan Status',
    description: 'Deskripsi',
    creationDate: 'Tanggal pembuatan',
    lastStatusDate: 'Tanggal status terakhir',
    requestedAmount: 'Jumlah yang diminta',
    receiveAmount: 'Jumlah yang diterima',
    transferAmount: 'Jumlah transfer',
    amountToPay: 'Jumlah yang harus dibayar',
    transferFee: 'Biaya transfer',
    processingFee: 'Biaya pemrosesan',
    method: 'Metode',
    country: 'Negara',
    name: 'Nama',
    bankPendingText: 'Dalam tinjauan bank final',
    pendingText: 'Dalam tinjauan {0}',
    chametSalary: 'Gaji Chamet',
    userSalary: 'Gaji pengguna',
    comm: 'Komunikasi.',
    gemgalaSalary: 'Gaji Gemgala'
  },
  transfer: {
    title: 'Ke Akun MetWallet',
    noPayPwdDialog: 'Harap tetapkan kata sandi pembayaran 6 digit sebelum transfer.',
    records: 'Catatan',
    cashInOut: 'Penarikan dana {0}, Penarikan dana {1}',
    transfer: 'Biaya',
    fee: 'Transfer',
    remark: 'Keterangan',
    transferTo: 'Transfer ke {0}',
    remarkPlaceholder: 'Tambahkan keterangan transfer (kurang dari 100 karakter)',
    firstNameNote: 'Silakan masukkan nama depannya',
    sendingAmount: 'Jumlah Pengiriman',
    receivingAmount: 'Jumlah Penerimaan',
    transferNow: 'Transfer Sekarang',
    noBalanceToast: 'Jumlah transfer lebih besar dari jumlah saldo.',
    amountTooLittleToast: 'Jumlah transfer tidak boleh kurang dari $10.'
  },
  bankData: {
    beneficiaryName: 'Nama Penerima',
    beneficiaryNamePlaceholder: 'Masukkan Nama',
    beneficiaryLastname: 'Nama Belakang Penerima',
    beneficiaryLastnamePlaceholder: 'Masukkan Nama Belakang',
    bankCode: 'Kode Bank',
    bankCodePlaceholder: 'Pilih Kode Bank',
    bankIFSCCode: 'Kode IFSC Bank',
    bankIFSCCodePlaceholder: 'Masukkan IFSC Bank',
    bankAccount: 'Rekening Bank',
    bankAccountPlaceholder: 'Masukkan Rekening Bank',
    email: 'Email',
    emailPlaceholder: 'Masukkan Email',
    phoneNumber: 'Nomor Telepon',
    phoneNumberPlaceholder: 'Masukkan Nomor Telepon',
    address: 'Alamat',
    addressPlaceholder: 'Masukkan Alamat',
    city: 'Kota',
    cityPlaceholder: 'Masukkan Kota',
    state: 'Negara Bagian',
    statePlaceholder: 'Masukkan Negara Bagian',
    postCode: 'Kode Pos',
    postCodePlaceholder: 'Masukkan Kode Pos',
    documentId: 'ID Dokumen',
    documentIdPlaceholder: 'Masukkan ID Dokumen',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'Jenis Dokumen',
    documentTypePlaceholder: 'Pilih Jenis Dokumen',
    accountType: 'Jenis Rekening',
    accountTypePlaceholder: 'Pilih Jenis Rekening',
    cpfcnpjPlaceholder: 'Masukkan CPFCNPJ',
    bankBranch: 'Cabang Bank',
    bankBranchPlaceholder: 'Masukkan Cabang Bank',
    ribOfBankAccount: 'RIB Rekening Bank',
    bankName: 'Nama Bank',
    bankNamePlaceholder: 'Masukkan Nama Bank',
    bicCode: 'Kode BIC',
    bicCodePlaceholder: 'Masukkan kode BIC',
    ibanPlaceholder: 'Masukkan IBAN',
    bankSwift: 'Swift Bank',
    bankSwiftPlaceholder: 'Masukkan Swift Bank',
    name: 'Nama',
    documentCountry: 'Negara Dokumen',
    documentCountryPlaceholder: 'Pilih Negara Dokumen',
    issueDate: 'Tanggal Terbit Dokumen',
    issueDatePlaceholder: 'Pilih Tanggal Terbit',
    expireDate: 'Tanggal Kedaluwarsa Dokumen',
    expireDatePlaceholder: 'Pilih Tanggal Kedaluwarsa',
    bankBranchName: 'Nama Cabang Bank',
    bankBranchNamePlaceholder: 'Masukkan Nama Cabang',
    branchPlaceholder: 'Masukkan Cabang',
    gender: 'Jenis Kelamin',
    genderPlaceholder: 'Pilih Jenis Kelamin',
    birthday: 'Ulang Tahun',
    birthdayPlaceholder: 'Pilih Ulang Tahun',
    phone: 'Telepon',
    bankAddress: 'Alamat Bank',
    bankAddressPlaceholder: 'Masukkan Alamat Bank',
    bankAccountName: 'Nama Rekening Bank',
    bankAccountNamePlaceholder: 'Masukkan Nama Rekening Bank',
    province: 'Provinsi',
    provincePlaceholder: 'Masukkan Provinsi',
    postalCode: 'Kode Pos',
    postalCodePlaceholder: 'Masukkan Kode Pos',
    savingsAccount: 'Rekening Tabungan',
    abaRoutingNumber: 'Nomor routing ABA',
    englandBankAccount: 'Rekening Bank Inggris',
    bankBranch2: 'bankBranch',
    bankBranch2Placeholder: 'Hanya jika banknya Santander',
    paternalName: 'Nama Ayah',
    paternalNamePlaceholder: 'Masukkan Nama Ayah',
    passportIdNumber: 'Nomor ID Paspor',
    bankNamePlaceholder2: 'Pilih Nama Bank',
    areaCode: 'Kode Area',
    phoneNumberNoAreaCode: 'Nomor Telepon (Tanpa Kode Area)',
    idType: 'Jenis ID',
    idNo: 'Nomor ID',
    idIssueDate: 'Tanggal Penerbitan ID',
    idExpireDate: 'Tanggal Kedaluwarsa ID',
    ibanStyleToast: "Harap masukkan konten yang diawali dengan 'SA' dengan panjang 24 karakter."
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'Anda hanya dapat mentransfer ke Penjual Berlian',
    search: 'Pencarian',
    history: 'Pengguna yang ditransfer',
    confirm_content: 'Anda yakin akan mentransfer {0} ke {1}',
    success_content: '{0} telah ditransfer ke {1}',
    purchase: 'Pembelian',
    purchase_success: 'Anda telah berhasil membeli {0}',
    insufficient_balance: 'Saldo tidak mencukupi',
    purchase_diamond: 'Pembelian Berlian',
    transfer_limit_2: 'Jumlah transfer harus antara $10 dan $30.000',
    no_data: 'Tidak Ada Data',
    invalid_number: 'Harap masukkan angka yang valid',
    under_limit: 'Jumlah transfer tidak boleh kurang dari $10',
    over_limit: 'Jumlah transfer tidak boleh kurang dari $30.000'
  },
  redesign: {
    emailPlaceholder: 'Masukkan alamat email',
    retrievePwd: 'Ambil kembali kata sandi',
    resetPwd: 'Atur ulang kata sandi',
    newPwdPlaceholder: 'Masukkan kata sandi baru',
    reenterNewPwdPlaceholder: 'Masukkan kembali kata sandi baru',
    reenterPayPwdPlaceholder: 'Silakan masukkan kembali kata sandi pembayaran',
    sendToPhone: 'Kode verifikasi telah dikirim ke ponsel Anda',
    sendToWhatsapp: 'Kode verifikasi telah dikirim ke WhatsApp Anda',
    sendToEmail: 'Kode verifikasi telah dikirim ke email Anda',
    invalidCode: 'Kode tidak valid',
    userId: 'ID Pengguna',
    other: 'Lainnya',
    transactionRecord: 'Catatan Transaksi',
    bankCardInfo: 'Rekening kartu bank',
    withdrawInfo: 'Rekening penarikan',
    toFillIn: 'Harus diisi',
    walletInfo: 'Informasi rekening dompet',
    toComplete: 'Harus dilengkapi',
    verifyGuide: 'Lengkapi informasi rekening dompet untuk memperoleh kualifikasi penarikan lebih lanjut',
    verifyNote: 'Lengkapi informasi berikut untuk memperoleh kualifikasi penarikan harian sebesar {0}',
    verifyCompletedNote: 'Informasi dilengkapi untuk memperoleh kualifikasi penarikan harian sebesar {0}',
    continueBtnText: 'Lanjutkan pengisian',
    submitInfo: 'Kirim informasi',
    transferAmount: 'Jumlah transfer',
    newEmailVerify: 'Verifikasi Email baru',
    verifyCodePlaceholder: 'Masukkan kode verifikasi',
    emailIncorrectToast: 'Silakan masukkan alamat email yang benar',
    newPhone: 'Nomor telepon baru',
    accountAdded: 'Informasi rekening ditambahkan',
    accountToAdd: 'Akun lain dapat ditambahkan',
    edit: 'Edit',
    enterPayPwd: 'Masukkan kata sandi pembayaran',
    deleteBtnText: 'Hapus',
    transferTo: 'Transfer ke',
    withdrawable: 'Dapat ditarik',
    goSet: 'Ayo atur',
    goModify: 'Ayo modifikasi'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/id.js